$(document).ready(function () {

    // ============================================================
    // CONFIG — adjust these to match your theme
    // ============================================================
    // These must be the actual section *ids* (filename without .liquid)
    // that render the markup containing #slidingcartmain and the
    // cart count bubble. Check sections/*.liquid in your theme.
    const SECTION_CART_DRAWER = "slidecart";
    const SECTION_CART_ICON   = "header";
    const CART_SECTIONS       = SECTION_CART_DRAWER + "," + SECTION_CART_ICON;

    let url_p = "/cart#slidingcartmain";
    if (window.location.href.indexOf("/en-en") > -1) {
        url_p = "/en-en/cart#slidingcartmain";
    } else if (window.location.href.indexOf("/es-es") > -1) {
        url_p = "/es-es/cart#slidingcartmain";
    } else if (window.location.href.indexOf("/it-it") > -1) {
        url_p = "/it-it/cart#slidingcartmain";
    } else if (window.location.href.indexOf("/de-de") > -1) {
        url_p = "/de-de/cart#slidingcartmain";
    }

    // ============================================================
    // CURRENCY SYNC — only do this once per session, not per add
    // ============================================================
    let _currencySynced = false;
    function ensureCurrencySynced(cb) {
        if (_currencySynced) { cb(); return; }
        const activeCurrency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        if (!activeCurrency) { cb(); return; }
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: JSON.stringify({ currency: activeCurrency }),
            contentType: "application/json",
            dataType: "json",
            success: function () { _currencySynced = true; cb(); },
            error: function () { cb(); } // don't block UI on this failing
        });
    }
    ensureCurrencySynced(function () {});

    function formatMoney(amount, locale = "fr-FR") {
        const currentCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
        let formatted = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currentCurrency,
            minimumFractionDigits: 2
        }).format(amount);
        if (currentCurrency === "USD") {
            let cleanNumber = formatted.replace(/[^\d.,]/g, "").trim();
            return `$${cleanNumber}`;
        }
        return formatted;
    }

    function getDeleteData(url){
          $.ajax({
          type: 'GET',
          url: url,
          dataType: 'json',
          success: function(cartdata){
            $('.cart-count-bubble span').html(cartdata.item_count);
            if(cartdata.item_count > 0){
              if($(".cart-count-bubble").length > 0){
                
              }else{
                $(".header__icon--cart").append("<div class='cart-count-bubble'><span aria-hidden='true'>"+ cartdata.item_count +"</span></div>")
              }
              $('.cart-count-bubble').removeClass('visually-hidden');
            }
            if(cartdata.item_count == 0){
              $('.cart-count-bubble').addClass('visually-hidden');
              $(".inline-cart").addClass("cart_empty")
            }
            $.ajax({
              type: "GET",
              url: url,
              dataType: 'html',
              success: function(data) {
                var minicartdata = $(data).filter('#slidingcartmain').html();
               var maincart = $(minicartdata).find('.slidecartitmmain').html();
                var maincartprice = $(minicartdata).find('.slidecart_form').html();
                   var progree_msg = $(data).find(".cust-shptxt").html();
                var progree_width = $(data).find(".cust-prg b").attr("style");
                  if (window.location.href.indexOf("/cart") > -1) {
                    var cartdata = $(data).find('.c_cart_items').html();
                    $('.c_cart_items').html(cartdata);
                     var carttotals = $(data).find('.price-subtotals').html();       
                    $('.price-subtotals').html(carttotals);
                    if($(data).find(".slidecart_items .line-item").length == 0){
                      $(".c_cart_container .empty_cart").css("display","flex");
                      $(".c_cart_container .cart_subtotal_mobile").addClass("hidden")
                      $(".c_cart_container .reserved_text").css("display","none");
                      $(".c_cart_container .c_cart_items").css("display","none");
                      $(".c_cart_container .c_cart_checkout").css("display","none");
                    }
                  }
                  $('#slidingcartmain').html(minicartdata);
                 setTimeout(function(){
                   upsells_slick();
                },200)


              }
            });
          }
        });
}
function check_promo(){
  
  $.ajax({
          type: 'GET',
          url: url_p,
          dataType: 'json',
          success: function(cartdata){
                if(cartdata.cart_level_discount_applications?.[0]?.title) {
                  $("#discount-code-input").val(cartdata.cart_level_discount_applications[0].title);
                  $(".promo_added").css("display","flex");
                  $(".promo_remove").css("display","flex");
                   $("#discount-code-input").attr("disabled","disabled");
                  setTimeout(function(){             
                     let priceElement = document.querySelector("#cart_original_price span");
                      let originalText = priceElement.innerHTML;

                      // Extract the currency symbol (everything that's NOT a digit, comma, or dot)
                      let currencyMatch = originalText.match(/[^\d,\.]+$/); // Matches non-digit characters at the end
                      let currency_no_price = currencyMatch ? currencyMatch[0] : '';

                      // Extract price number (all digits and comma/decimal point)
                      let priceMatch = originalText.match(/[\d,\.]+/);
                      let price_no_currency_or = priceMatch ? priceMatch[0] : '';
                      $(".promo_price").html((cartdata.total_price/100).toFixed(2) + currency_no_price);
                       $("#cart_original_price span").addClass("strikeprice");
                  },500)
                  
                }

          }
 })
}
check_promo();
function upsells_slick(){
 check_promo();
if(document.querySelector(".upsells_container") != null){
if(document.querySelector(".upsells_container").classList.contains("slick-slider")){
 $('.upsells_container').slick('unslick');
}

  $('.upsells_container').slick({
   dots: false, 
   arrows: true,
    infinite: true,
    autoplay:false,
    slidesToShow:1,slidesToScroll:1,
        draggable: true,
       swipe:true,
        prevArrow:$(".splide__arrow--prev"),
        nextArrow:$(".splide__arrow--next"),
    
  });
}
}
function showCartSkeleton() {
  if ($(".slidecart_items .cart-skeleton").length) return;
  const rows = Array.from({ length: 3 }).map(() => `
    <div class="sk-row">
      <div class="sk-block" style="width:56px;height:56px;flex-shrink:0;"></div>
      <div style="flex:1;display:flex;flex-direction:column;gap:8px;justify-content:center;">
        <div class="sk-block" style="height:12px;width:80%;"></div>
        <div class="sk-block" style="height:12px;width:40%;"></div>
      </div>
    </div>
  `).join("");
  $(".slidecart_items").append(`
    <div class="cart-skeleton">
      ${rows}
      <div class="sk-block" style="height:40px;width:100%;margin-top:1rem;"></div>
    </div>
  `);
}

function hideCartSkeleton() {
  $(".slidecart_items .cart-skeleton").remove();
}
    // ============================================================
    // DRAWER OPEN / CLOSE (instant, optimistic)
    // ============================================================
    function openDrawer(loading) {
        $("#overlay").addClass("is-active");
        $(".inline-cart").addClass("is-active").removeClass("cart_empty");
        $("body").addClass("cstm_toggle_cls slidecart-is-open");
        $("html").addClass("slidecart-is-open");
         if (loading) {
            $(".inline-cart").addClass("is-loading");
            if ($(".alm-cart-empty").length){
                    showCartSkeleton();
            }
            
        }
    }
    
// Global variable to keep track of the active interval
let cartTimerInterval = null;

function initSlidecartTimer(itemCount) {
    const $container = $('#slidecart-reserved-timer-container');
    const $display = $('#slidecart-countdown-display');
    
    // Check if element exists and if the timer is enabled via theme settings
    if (!$container.length || $container.data('timer-enabled') !== true || !$display.length) {
        return;
    }

    const durationMinutes = parseInt($container.data('timer-duration'), 10) || 10;
    const cartCount = parseInt(itemCount, 10);

    // 1. If cart is empty, clear any running timer and remove stored timestamp
    if (isNaN(cartCount) || cartCount <= 0) {
        clearInterval(cartTimerInterval);
        localStorage.removeItem('slidecart_timer_expires');
        $display.text('');
        return;
    }

    // 2. Retrieve or set target expiration timestamp
    let expirationTime = localStorage.getItem('slidecart_timer_expires');
    const now = new Date().getTime();

    // FIX: If no timestamp exists OR the stored timestamp has already passed, reset the timer
    if (!expirationTime || parseInt(expirationTime, 10) <= now) {
        expirationTime = now + (durationMinutes * 60 * 1000);
        localStorage.setItem('slidecart_timer_expires', expirationTime);
    } else {
        expirationTime = parseInt(expirationTime, 10);
    }

    // 3. Clear existing interval loop to prevent duplicating cycles
    clearInterval(cartTimerInterval);

    // 4. Start the countdown runner
    function updateTimer() {
        const currentTime = new Date().getTime();
        const timeLeft = expirationTime - currentTime;

        if (timeLeft <= 0) {
            clearInterval(cartTimerInterval);
            localStorage.removeItem('slidecart_timer_expires');
            $display.text("00:00");
            return;
        }

        // Calculate minutes and seconds
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        // Format with leading zeroes (e.g., "09:05")
        const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
        const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

        $display.text(formattedMinutes + ":" + formattedSeconds);
    }

    updateTimer(); // Run once immediately to avoid a 1-second delay
    cartTimerInterval = setInterval(updateTimer, 1000);
}

// Ensure the timer automatically boots up when the page finishes loading
$(document).ready(function() {
    let initialCount = 0;
    if (window.Shopify && window.Shopify.cart) {
        initialCount = window.Shopify.cart.item_count;
    } else if ($('.cart-count-bubble span').length) {
        initialCount = parseInt($('.cart-count-bubble span').first().text(), 10) || 0;
    }
    initSlidecartTimer(initialCount);
});

// Ensure the timer automatically boots up when the page finishes loading
$(document).ready(function() {
    // Read current cart count from Shopify's global cart object if available, otherwise check your bubble DOM
    let initialCount = 0;
    if (window.Shopify && window.Shopify.cart) {
        initialCount = window.Shopify.cart.item_count;
    } else if ($('.cart-count-bubble span').length) {
        initialCount = parseInt($('.cart-count-bubble span').first().text(), 10) || 0;
    }
    initSlidecartTimer(initialCount);
});

    function closeDrawer() {
        $("#overlay").removeClass("is-active");
        $(".inline-cart").removeClass("is-active");
        $("body").removeClass("slidecart-is-open cstm_toggle_cls");
        $("html").removeClass("slidecart-is-open");
    }

    // ============================================================
    // CORE: inject rendered sections into the DOM
    // response must contain response.sections[SECTION_CART_DRAWER] and
    // response.sections[SECTION_CART_ICON] (raw HTML strings)
    // ============================================================
    function renderCartSections(response) {
        if (!response || !response.sections) return;

        const drawerHtml = response.sections[SECTION_CART_DRAWER];
        const iconHtml = response.sections[SECTION_CART_ICON];

        if (drawerHtml) {
            const $drawer = $(drawerHtml);
            const minicartData = $drawer.filter("#slidingcartmain").length
                ? $drawer.filter("#slidingcartmain").html()
                : $("<div>").html(drawerHtml).find("#slidingcartmain").html();

            if (minicartData != null) {
                $("#slidingcartmain").html(minicartData);
            }

            // If we're on /cart, also refresh the full-page cart blocks
            if (window.location.href.indexOf("/cart") > -1) {
                const $src = $("<div>").html(drawerHtml);
                const cartItemsHtml = $src.find(".c_cart_items").html();
                const cartTotalsHtml = $src.find(".price-subtotals").html();
                if (cartItemsHtml != null) $(".c_cart_items").html(cartItemsHtml);
                if (cartTotalsHtml != null) $(".price-subtotals").html(cartTotalsHtml);

                const hasLineItems = $src.find(".slidecart_items .line-item").length > 0;
                $(".c_cart_container .empty_cart").css("display", hasLineItems ? "none" : "flex");
                $(".c_cart_container .cart_subtotal_mobile").toggleClass("hidden", !hasLineItems);
                $(".c_cart_container .reserved_text").css("display", hasLineItems ? "flex" : "none");
                $(".c_cart_container .c_cart_items").css("display", hasLineItems ? "block" : "none");
                $(".c_cart_container .c_cart_checkout").css("display", hasLineItems ? "block" : "none");
            }
        }

        if (iconHtml) {
            const $icon = $("<div>").html(iconHtml);
            const bubbleHtml = $icon.find(".cart-count-bubble").length
                ? $icon.find(".cart-count-bubble").html()
                : null;
            if (bubbleHtml != null) {
                $(".cart-count-bubble span").html(response.item_count != null ? response.item_count : bubbleHtml);
            }
        }

        if (response.item_count != null) {
            initSlidecartTimer(response.item_count);
            $("#cart-count").html(response.item_count);
            $(".cart-count-bubble span").html(response.item_count);
            if (response.item_count > 0) {
                if (!$(".cart-count-bubble").length) {
                    $(".header__icon--cart").append(
                        "<div class='cart-count-bubble'><span aria-hidden='true'>" + response.item_count + "</span></div>"
                    );
                }
                $(".cart-count-bubble").removeClass("visually-hidden");
            } else {
                $(".cart-count-bubble").addClass("visually-hidden");
                $(".inline-cart").addClass("cart_empty");
            }
        }

        $(".inline-cart").removeClass("is-loading");
        $("#slidingcartmain").removeClass("slide_empty");
        if (response.item_count > 0) {
        $(".alm-cart-empty").remove();
        }
        $(".product-form__submit").removeClass("active");
        $("#cartCheckout").removeClass("active");

        setTimeout(upsells_slick, 100);
    }

    // ============================================================
    // Generic helpers hitting Shopify's native cart endpoints
    // with the sections param so we get fresh HTML in ONE request
    // ============================================================
    function cartAdd(items, opts) {
        opts = opts || {};
        const payload = { items: items, sections: CART_SECTIONS };
        return $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify(payload),
            contentType: "application/json",
            dataType: "json"
        });
    }

    function cartChange(line, quantity) {
        return $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
                line: line,
                quantity: quantity,
                sections: CART_SECTIONS
            },
            dataType: "json"
        });
    }

    function cartFetch() {
        return $.ajax({ type: "GET", url: "/cart.js", dataType: "json" });
    }

    function serializedFormToItems($container) {
        // Accepts a <form>, a wrapping element containing form controls
        // (e.g. .c_free_products_form which wraps a <form>), or a jQuery
        // collection of input/select/textarea elements directly.
        //
        // Reads each field explicitly rather than relying on jQuery's
        // generic serializeArray(), so <select name="id"> always resolves
        // to its currently selected <option>'s value.
        const isForm = $container.is("form");
        const $fields = isForm ? $container.find("input,select,textarea") : $container.find("input,select,textarea");
 
        const item = { properties: {} };
 
        function assign(name, value) {
            if (!name || value == null) return;
            if (name === "id") {
                item.id = value;
            } else if (name === "quantity") {
                item.quantity = parseInt(value, 10) || 1;
            } else if (name.indexOf("properties[") === 0) {
                const key = name.replace("properties[", "").replace("]", "");
                item.properties[key] = value;
            }
        }
              $fields.filter("select").each(function () {
            const $sel = $(this);
            const name = $sel.attr("name");
            // Explicitly read the selected option's value rather than
            // trusting .val() alone — this is the reliable source of truth.
            const $selected = $sel.find("option:selected");
            const value = $selected.length ? $selected.val() : $sel.val();
            assign(name, value);
        });
 
        $fields.filter("input,textarea").each(function () {
            const $el = $(this);
            const type = ($el.attr("type") || "").toLowerCase();
            if ((type === "checkbox" || type === "radio") && !$el.is(":checked")) return;
            assign($el.attr("name"), $el.val());
        });
 
        if (!item.quantity) item.quantity = 1;
        if (Object.keys(item.properties).length === 0) delete item.properties;
 
        if (!item.id) {
            console.warn("serializedFormToItems: no id field resolved for container:", $container);
        }
 
        return item;
    }

    // ============================================================
    // FREE PRODUCTS (threshold-based) — unchanged logic, kept as a
    // fallback pass after any cart mutation. Batches its own add/remove.
    // ============================================================
    /*
    function syncFreeProducts() {
        let staticPromise = Promise.resolve();
        if ($(".free_products_form form:first-child").length > 0 &&
            $(".line-item[data_free]").length === 0) {
            const items = [];
            $(".free_products_form form").each(function () {
                items.push(serializedFormToItems($(this)));
            });
            if (items.length) {
                staticPromise = cartAdd(items);
            }
        }
        let thresholdPromise = Promise.resolve();
        const $threshold = $(".free_product_amount");
        if ($threshold.length) {
            const amountText = $threshold.data("amount") || "";
            const numericPart = amountText.replace(/[^\d,.]/g, "").replace(",", ".");
            const threshold = parseFloat(numericPart) * 100;
            const variantId = $threshold.find("[name='id']").val();
            if (variantId && !isNaN(threshold)) {
                thresholdPromise = cartFetch().then(function (cartData) {
                    const total = cartData.total_price;
                    const existingItem = cartData.items.find(item => item.variant_id == variantId);

                    const isPresent = !!existingItem;
                    if (total >= threshold && !isPresent) {
                        return cartAdd([{ id: variantId, quantity: 1 }]);
                    } else if (total < threshold && isPresent) {
                        const line = existingItem.index + 1;
                        return cartChange(line, 0);
                    }
                    return Promise.resolve();
                });
            }
        }
        return staticPromise
            .then(() => thresholdPromise)
            .then((finalResponse) => {
                // Whatever the last mutation returned, if it has sections, render them.
                if (finalResponse && finalResponse.sections) {
                    renderCartSections(finalResponse);
                } else {
                    refreshDrawerOnly();
                }
            })
            .catch(err => {
                console.error("Free product sync error:", err);
                refreshDrawerOnly();
            });
    } 
   function syncFreeProducts() {
    let staticPromise = Promise.resolve();

    // 1. Static Free Products Check
    if ($(".free_products_form form").length > 0) {
        const items = [];
        $(".free_products_form form").each(function () {
            const itemData = serializedFormToItems($(this));
            if (Array.isArray(itemData)) {
                items.push(...itemData);
            } else if (itemData) {
                items.push(itemData);
            }
        });

        // Check if these items are missing before trying to add them
        if (items.length) {
            staticPromise = cartFetch().then(function (cartData) {
                const missingItems = items.filter(newItem => {
                    const id = newItem.id || newItem.variant_id;
                    return !cartData.items.some(cartItem => cartItem.variant_id == id);
                });

                if (missingItems.length > 0) {
                    return cartAdd(missingItems);
                }
                return Promise.resolve();
            });
        }
    }

    // 2. Threshold Free Products Check
    let thresholdPromise = Promise.resolve();
    const $threshold = $(".free_product_amount");

    if ($threshold.length) {
        const amountText = $threshold.data("amount") || "";
        const numericPart = amountText.replace(/[^\d,.]/g, "").replace(",", ".");
        const threshold = parseFloat(numericPart) * 100;
        const variantId = $threshold.find("[name='id']").val();

        if (variantId && !isNaN(threshold)) {
            thresholdPromise = cartFetch().then(function (cartData) {
                const total = cartData.total_price;
                
                // Find existing item and store its index positions safely
                let itemIndex = -1;
                const existingItem = cartData.items.find((item, idx) => {
                    if (item.variant_id == variantId) {
                        itemIndex = idx + 1; // 1-based index for cart/change.js
                        return true;
                    }
                    return false;
                });

                const isPresent = !!existingItem;

                if (total >= threshold && !isPresent) {
                    return cartAdd([{ id: variantId, quantity: 1 }]);
                } else if (total < threshold && isPresent) {
                    // Prefer key if supported by cartChange, fall back to line item index
                    const lineId = existingItem.key || itemIndex;
                    return cartChange(lineId, 0);
                }
                return Promise.resolve();
            });
        }
    }

    return staticPromise
        .then(() => thresholdPromise)
        .then((finalResponse) => {
            if (finalResponse && finalResponse.sections) {
                renderCartSections(finalResponse);
            } else {
                refreshDrawerOnly();
            }
        })
        .catch(err => {
            console.error("Free product sync error:", err);
            refreshDrawerOnly();
        });
}*/

function syncFreeProducts(cartData) {
    // Reuse the cart from the caller; only fetch if none was passed
    const cartPromise = cartData ? Promise.resolve(cartData) : cartFetch();

    return cartPromise
        .then(function (cart) {
            const findInCart = function (id) {
                return cart.items.find(function (i) {
                    return i.variant_id == id;
                });
            };

            const toAdd = [];
            let removeKey = null;

            // 1. Static free products: add any that are missing
            $(".free_products_form form").each(function () {
                const itemData = serializedFormToItems($(this));
                [].concat(itemData || []).forEach(function (item) {
                    const id = item.id || item.variant_id;
                    const alreadyQueued = toAdd.some(function (a) {
                        return (a.id || a.variant_id) == id;
                    });
                    if (id && !findInCart(id) && !alreadyQueued) {
                        toAdd.push(item);
                    }
                });
            });

            // 2. Threshold free product: add or remove based on cart total
            const $threshold = $(".free_product_amount");
            if ($threshold.length) {
                const amountText = String($threshold.data("amount") || "");
                const numericPart = amountText.replace(/[^\d,.]/g, "").replace(",", ".");
                const threshold = parseFloat(numericPart) * 100;
                const variantId = $threshold.find("[name='id']").val();

                if (variantId && !isNaN(threshold)) {
                    const existing = findInCart(variantId);
                    const alreadyQueued = toAdd.some(function (a) {
                        return (a.id || a.variant_id) == variantId;
                    });

                    if (cart.total_price >= threshold && !existing && !alreadyQueued) {
                        toAdd.push({ id: variantId, quantity: 1 });
                    } else if (cart.total_price < threshold && existing) {
                        removeKey = existing.key;
                    }
                }
            }

            // Nothing to change: no requests, no re-render
            if (!toAdd.length && !removeKey) return null;

            let chain = Promise.resolve(null);

            if (toAdd.length) {
                chain = chain
                    .then(function () { return cartAdd(toAdd); })
                    .then(function (res) {
                        // add.js doesn't return item_count, so compute it
                        const added = toAdd.reduce(function (n, i) {
                            return n + (parseInt(i.quantity, 10) || 1);
                        }, 0);
                        return Object.assign({}, res, {
                            item_count: cart.item_count + added
                        });
                    });
            }

            if (removeKey) {
                // change.js returns the full cart, including item_count
                chain = chain.then(function () { return cartChange(removeKey, 0); });
            }

            return chain;
        })
        .then(function (response) {
            if (!response) return; // nothing changed, drawer is already correct

            if (response.sections) {
                renderCartSections(response);
            } else {
                refreshDrawerOnly();
            }
        })
        .catch(function (err) {
            console.error("Free product sync error:", err);
            refreshDrawerOnly();
        });
}



    // Fallback: fetch just the drawer sections via cart/update.js (no full page GET)
    function refreshDrawerOnly() {
        $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: JSON.stringify({ sections: CART_SECTIONS }),
            contentType: "application/json",
            dataType: "json",
            success: renderCartSections
        });
    }

    // ============================================================
    // PROMO CODE
    // ============================================================
    function check_promo() {
        cartFetch().then(function (cartdata) {
            if (cartdata.cart_level_discount_applications?.[0]?.title) {
                $("#discount-code-input").val(cartdata.cart_level_discount_applications[0].title);
                $(".promo_added").css("display", "flex");
                $(".promo_remove").css("display", "flex");
                $("#discount-code-input").attr("disabled", "disabled");

                let priceElement = document.querySelector("#cart_original_price span");
                if (priceElement) {
                    let originalText = priceElement.innerHTML;
                    let currencyMatch = originalText.match(/[^\d,\.]+$/);
                    let currency_no_price = currencyMatch ? currencyMatch[0] : "";
                    $(".promo_price").html((cartdata.total_price / 100).toFixed(2) + currency_no_price);
                    $("#cart_original_price span").addClass("strikeprice");
                }
            }
        });
    }
    check_promo();

    function coupon_add() {
        var promoCode = $("#discount-code-input").val();
        $(".discount-code__submit svg").css("display", "flex");
        $.ajax({
            url: "/discount/" + promoCode,
            type: "GET",
            success: function () {
                cartFetch().then(function (cartdata) {
                    $(".discount-code__submit svg").css("display", "none");
                    if (cartdata.cart_level_discount_applications[0].title != null) {
                        $("#discount-code-input").val(cartdata.cart_level_discount_applications[0].title);
                        $("#discount-code-input").attr("disabled", "disabled");
                        $(".promo_remove").css("display", "flex");
                        $(".promo_added").css("display", "flex");
                    }
                    let priceElement = document.querySelector("#cart_original_price");
                    if (priceElement) {
                        let originalText = priceElement.innerHTML;
                        let currencyMatch = originalText.match(/[^\d,\.]+/);
                        let currency_no_price = currencyMatch ? currencyMatch[0] : "";
                        $(".promo_price").html(currency_no_price + (cartdata.total_price / 100).toFixed(2));
                        $("#cart_original_price span").addClass("strikeprice");
                    }
                });
            },
            error: function (xhr) {
                alert("An error occurred: " + xhr.responseText);
            }
        });
    }

    function promo_remove() {
        $(".discount-code__submit svg").css("display", "flex");
        fetch(window.Shopify.routes.root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
            body: JSON.stringify({ attributes: { discount: "" }, discount: "" })
        })
            .then(() => fetch("/discount/clear"))
            .then(() => fetch(window.Shopify.routes.root + "cart.js"))
            .then(response => response.json())
            .then(cart => {
                if (cart.total_discount === 0) {
                    $("#discount-code-input").val("").removeAttr("disabled");
                    $(".promo_remove, .promo_added").hide();
                    $(".promo_price").html("");
                    $("#cart_original_price span").removeClass("strikeprice");
                    $(".discount-code__submit svg").hide();
                } else {
                    window.location.reload();
                }
            })
            .catch(error => {
                console.error("Error:", error);
                $(".discount-code__submit svg").hide();
            });
    }

    // ============================================================
    // UPSELLS SLIDER
    // ============================================================
    function upsells_slick() {
        check_promo();
        if (document.querySelector(".upsells_container") != null) {
            if (document.querySelector(".upsells_container").classList.contains("slick-slider")) {
                $(".upsells_container").slick("unslick");
            }
            $(".upsells_container").slick({
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                draggable: true,
                swipe: true,
                prevArrow: $(".splide__arrow--prev"),
                nextArrow: $(".splide__arrow--next")
            });
        }
    }
    upsells_slick();

    // Card size-value buttons (quick add w/ variant + free product bundling)
  $(document).on("click", ".card__size-value button", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $btn = $(this);
        if ($btn.data("processing")) return;
        $btn.data("processing", true);
 
        openDrawer(true);
 
        let elements = $(this);
        let selectedVariantId = $(this).attr("id");
        let freeProductForm = elements.closest(".card-grid-centered").find(".c_free_products_form");
        let proVarsOptions = freeProductForm.find(".pro_vars div");
        let selectedButtonText = $(this).text().trim().replace(/\s+/g, " ");
        let matchingProVar = proVarsOptions.filter(function () {
            return $(this).text().trim().replace(/\s+/g, " ") === selectedButtonText;
        });
 
        const items = [];
        const $sizeForm = elements.closest(".card__size-value");
        const mainItem = serializedFormToItems($sizeForm);
        if (selectedVariantId) mainItem.id = selectedVariantId; // button's id attr IS the variant id
        items.push(mainItem);
 
        const $freeInputs = freeProductForm.find("input,select,textarea");
        if ($freeInputs.length) {
            const freeVariantId = matchingProVar.length
                ? matchingProVar.attr("data-id")
                : proVarsOptions.first().attr("data-id");
            freeProductForm.find("[name='id']").val(freeVariantId);
            items.push(serializedFormToItems(freeProductForm));
        }
 
        cartAdd(items)
            .then(function (addResponse) {
                // FIX: Fetch full cart object so we have the accurate item_count
                return cartFetch().then(function (cartData) {
                    // Combine added section data with total item count from cart
                    const mergedResponse = Object.assign({}, addResponse, {
                        item_count: cartData.item_count
                    });
                    
                    renderCartSections(mergedResponse);
                     return syncFreeProducts(cartData);
                });
            })
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                const desc = resp && resp.responseJSON && resp.responseJSON.description;
                alert(desc || "Could not add this item to your cart.");
            })
            .always(function () {
                $btn.data("processing", false);
            });
    });

    // ============================================================
    // DRAWER OPEN/CLOSE TRIGGERS
    // ============================================================
    $(".header__icon--cart").click(function (e) {
        e.preventDefault();
        if ($(location).attr("href").includes("/cart")) return;
        openDrawer(false);
    });

    $(document).on("click", ".clscrt", function () { closeDrawer(); });
    $("body").on("click", ".continueshopping", function (e) { e.preventDefault(); closeDrawer(); });
    $("body").on("click", "#overlay", function () { closeDrawer(); });
    $(".top_header_new_cart").click(function () { $("body").addClass("cstm_toggle_cls"); });
    $("#overlay").click(function () { $("body").removeClass("cstm_toggle_cls"); });

    // ============================================================
    // QUANTITY STEPPER (+/-)
    // ============================================================
    $("body").on("click", ".qtyplus", function () {
        var t = +$(this).siblings(".changequantity").val() + 1;
        $(this).siblings(".changequantity").val(t);
    });

    $("body").on("click", ".qtyminus", function () {
        var t = +$(this).siblings(".changequantity").val() - 1;
        if (t < 1) t = 1;
        $(this).siblings(".changequantity").val(t);
    });

    $("body").on("click", ".qtyplus, .qtyminus", function () {
        var qty = $(this).siblings(".changequantity").val();
        var line = $(this).siblings(".changequantity").attr("data-line-item-index");
        openDrawer(true);
        cartChange(line, qty)
            .then(renderCartSections)
            .catch(() => $(".inline-cart").removeClass("is-loading"));
    });

    $("body").on("change", ".changequantity", function () {
        var line = $(this).attr("data-line-item-index");
        var qty = $(this).val();
        openDrawer(true);
        cartChange(line, qty)
            .then(renderCartSections)
            .catch(() => $(".inline-cart").removeClass("is-loading"));
    });

    $("body").on("change", ".item-qty-selector", function () {
        var qty = $(this).find(":selected").val();
        var line = $(this).attr("data-line-item-index");
        var $element = $(this).closest(".line-item");
        $("#cartCheckout").addClass("active");

        cartChange(line, qty).then(function (data) {
            if ($element.find(".p_free_products_form").length) {
                const dataTitle = $element.find(".p_free_products_form").data("title");
                if (dataTitle) {
                    const baseDataTitle = extractBaseProductName(dataTitle);
                    const $matchingLineItem = $(".line-item-container").find(".line-item").filter(function () {
                        const itemTitle = $(this).find(".line-item-title a").text().trim();
                        return extractBaseProductName(itemTitle) === baseDataTitle;
                    });
                    if ($matchingLineItem.length > 0) {
                        const matchLine = $matchingLineItem.find(".item-qty-selector, .variant-option").first().data("line-item-index");
                        cartChange(matchLine, qty).then(renderCartSections);
                        return;
                    }
                }
            }
            renderCartSections(data);
        });
    });

    function extractBaseProductName(fullName) {
        return fullName.replace(/\s*\[.*?\]\s*/g, "").trim();
    }

    // ============================================================
    // VARIANT SWITCH (swap line item to a new variant)
    // ============================================================
    function updateCartItem(lineIndex, variantId) {
        openDrawer(true);
        $("#cartCheckout").addClass("active");
        cartAdd([{ id: variantId, quantity: 1 }])
            .then(function () {
                return cartChange(parseInt(lineIndex, 10) + 1, 0);
            })
            .then(renderCartSections)
            .catch(() => $(".inline-cart").removeClass("is-loading"));
    }

    function updateCartItem_x(lineIndex, variantId) {
        openDrawer(true);
        $("#cartCheckout").addClass("active");
        cartAdd([{ id: variantId, quantity: 1 }])
            .then(function () {
                return cartChange(parseInt(lineIndex, 10) + 1, 0);
            })
            .then(function (data) {
                renderCartSections(data);
                $(".cart_vars_colors select").prop("disabled", false);
            })
            .catch(function () {
                $(".cart_vars_colors select").prop("disabled", false);
                $(".inline-cart").removeClass("is-loading");
            });
    }

    $("body").on("change", ".variant-option", function () {
        const $this = $(this);
        const $container = $this.closest(".product-container");
        const variants = $container.data("variants");
        const productOptions = $container.data("options");
        const lineIndex = $container.data("line-item-index");
        const $variantIdInput = $container.find(".selected-variant-id");

        const selectedOptions = {};
        $container.find(".variant-option").each(function () {
            selectedOptions[$(this).data("option")] = $(this).val();
        });

        const selectedVariant = variants.find(variant =>
            variant.options.every((option, index) => {
                const optionName = productOptions[index].toLowerCase().replace(" ", "-");
                return option === selectedOptions[optionName];
            })
        );

        if (selectedVariant) {
            $variantIdInput.val(selectedVariant.id);
            updateCartItem(lineIndex, selectedVariant.id);
        }
    });

    $("body").on("change", ".cart_vars_colors select", function () {
        const $this = $(this);
        const $container = $this.closest(".cart_vars_colors");
        const lineIndex = $container.data("line-item-index");
        const selectedVariantId = $this.val();
        $this.prop("disabled", true);
        if (selectedVariantId) {
            updateCartItem_x(lineIndex, selectedVariantId);
        }
    });

    // ============================================================
    // REMOVE ITEM
    // ============================================================
        $("body").on("click", ".remove-item", function () {
        $(this).find(".removing_svg").css("display", "none");
        $(this).find(".rotating_svg").css("display", "block");
        var line = $(this).attr("data-line-item-index");

        cartChange(line, 0).then(function (response) {
            const onlyFreeItemsLeft =
                $(".slidecart_items .line-item").length ===
                $(".slidecart_items .line-item[data_free]").length + 1;

            if (onlyFreeItemsLeft) {
                $.ajax({
                    type: "POST",
                    url: "/cart/clear.js",
                    data: { sections: CART_SECTIONS },
                    dataType: "json",
                    success: renderCartSections
                });
            } else {
                renderCartSections(response);
            }
        });
    });

    // ============================================================
    // MAIN PRODUCT FORM — ADD TO CART
    // ============================================================
    $(".product-form__submit:not(.numbers_product)").click(function (e) {
        e.preventDefault();
        $(this).addClass("active");

        if ($(".custom_upsells").length) {
            $(".custom_upsells").addClass("active");
            return;
        }

        openDrawer(true);

        const items = [serializedFormToItems($(this).closest("form"))];
        if ($(".p_free_products_form form").length) {
            items.push(serializedFormToItems($(".p_free_products_form form")));
        }

         cartAdd(items)
        .then(function (addResponse) {
            // FIX: Fetch full cart object so we have the accurate item_count
            return cartFetch().then(function (cartData) {
                // Combine added section data with total item count from cart
                const mergedResponse = Object.assign({}, addResponse, {
                    item_count: cartData.item_count
                });
                
                renderCartSections(mergedResponse);
                 return syncFreeProducts(cartData);
            });
        })
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                const desc = resp && resp.responseJSON && resp.responseJSON.description;
                alert(desc || "Could not add this item to your cart.");
            });
    });

    $(document).on("change", ".upps_p_item .ups_variant-option", function () {
    const $item = $(this).closest(".upps_p_item");
    const $variantsWrap = $item.find(".upps_variants");
    const variants = $variantsWrap.data("variants"); // already parsed as array by jQuery
    const options = $variantsWrap.data("options");    // e.g. ["Size"]

    // collect current values of ALL option selects in this item, in order
    const selected = [];
    $item.find(".option-selector select.ups_variant-option").each(function () {
        selected.push($(this).val());
    });

    // match against option1/option2/option3
    const match = variants.find(v => {
        return selected.every((val, i) => v[`option${i + 1}`] === val);
    });

    if (match) {
        $item.find(".selected-variant-id").val(match.id);

        // optional: keep price display in sync too
        $item.find(".upps_prices .s").attr("data-price", match.price)
             .text("€" + (match.price / 100).toFixed(2).replace(".", ","));
    } else {
        console.warn("No matching variant found for", selected);
    }
});

    $(".upps_atc").click(function () {
        $(this).addClass("loading");
        openDrawer(true);

        const items = [];
        if ($(this).hasClass("active")) {
            items.push(serializedFormToItems(
                $(this).closest(".product_upps_c").find(".upps_p_item.active")
            ));
            console.log(serializedFormToItems($(this).closest(".product_upps_c").find(".upps_p_item.active")))
        }
        items.push(serializedFormToItems($(".product-form__submit").closest("form")));
        if ($(".p_free_products_form form").length) {
            items.push(serializedFormToItems($(".p_free_products_form form")));
        }

        cartAdd(items)
            .then(function (addResponse) {
                $(".custom_upsells").removeClass("active");
                $(".upps_atc").removeClass("loading");
                return cartFetch().then(function (cartData) {
                // Combine added section data with total item count from cart
                const mergedResponse = Object.assign({}, addResponse, {
                    item_count: cartData.item_count
                });
                
                renderCartSections(mergedResponse);
                return syncFreeProducts(cartData);
            });
            })
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                $(".upps_atc").removeClass("loading");
                alert((resp && resp.responseJSON && resp.responseJSON.description) || "Could not add to cart.");
            });
    });


        $(".ups_overlay,.product_upps_close").click(function () {
        openDrawer(true);

        const items = [];
        items.push(serializedFormToItems($(".product-form__submit").closest("form")));
        if ($(".p_free_products_form form").length) {
            items.push(serializedFormToItems($(".p_free_products_form form")));
        }

        cartAdd(items)
            .then(function (addResponse) {
                $(".custom_upsells").removeClass("active");
                $(".upps_atc").removeClass("loading");
                return cartFetch().then(function (cartData) {
                const mergedResponse = Object.assign({}, addResponse, {
                    item_count: cartData.item_count
                });
                
                renderCartSections(mergedResponse);
                return syncFreeProducts(cartData);
            });
            })
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                $(".upps_atc").removeClass("loading");
                alert((resp && resp.responseJSON && resp.responseJSON.description) || "Could not add to cart.");
            });
    });

    $(".product-form__submit.numbers_product").click(function (e) {
        e.preventDefault();
        if ($("#your-name").val() != "") {
            $("fieldset .swatch-flocage:last-child label").click();
        }
        $(this).addClass("active");
        openDrawer(true);

        cartAdd([serializedFormToItems($(this).closest("form"))])
            .then(function (addResponse) {
              return cartFetch().then(function (cartData) {
                const mergedResponse = Object.assign({}, addResponse, {
                    item_count: cartData.item_count
                });
                
                renderCartSections(mergedResponse);
                return syncFreeProducts(cartData);
            });
            })
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                alert((resp && resp.responseJSON && resp.responseJSON.description) || "Could not add to cart.");
            });
    });

    $(".custom-sticky").click(function (e) {
        e.preventDefault();
        $("#main-product .product-form__cart-submit").click();
    });

    // ============================================================
    // UPSELL SWATCHES + "ADD BOTH" BUTTON
    // ============================================================
    $(".ups_swatch-element").click(function () {
        $(this).closest(".ups_prod").find(".upsel_form [name='id']").attr("value", $(this).attr("data-id"));
        $(this).closest(".ups_prod").find(".ups_swatch-element").removeClass("active");
        $(this).addClass("active");
    });

    $(".upsels_btn").click(function (e) {
        e.preventDefault();
        openDrawer(true);

        const items = [
            serializedFormToItems($(".ups_prod_1 .upsel_form")),
            serializedFormToItems($(".ups_prod_2 .upsel_form"))
        ];


        cartAdd(items)
            .then(renderCartSections)
            .catch(function (resp) {
                $(".inline-cart").removeClass("is-loading");
                alert((resp && resp.responseJSON && resp.responseJSON.description) || "Could not add to cart.");
            });
    });

                // Unified Bundle Add-To-Cart Script Handler
            $(document).on("click", ".product-form__submit.numbers_product.bundles_c", function (e) {
                e.preventDefault();
                
                const $btn = $(this);
                const selectedItems = [];

                // Gather all checked variants from the modal popup
                $("#ModalProductContainer .variant-checkbox-input:checked").each(function () {
                selectedItems.push({
                    id: $(this).data("variant-id"),
                    quantity: 1
                });
                });

                if (selectedItems.length === 0) {
                alert("Please select at least one item variant.");
                return;
                }

                if ($("#your-name").val() != "" && $("#your-name").length) {
                $("fieldset .swatch-flocage:last-child label").click();
                }
                
                $btn.addClass("active");
                if (typeof openDrawer === "function") openDrawer(true);

                if (typeof cartAdd === "function") {
                // Pass array of all selected items to cartAdd helper
                cartAdd(selectedItems)
                    .then(function (response) {
                    if (typeof renderCartSections === "function") renderCartSections(response);
                    if (typeof syncFreeProducts === "function") return syncFreeProducts(response);
                    })
                    .catch(function (resp) {
                    $(".inline-cart").removeClass("is-loading");
                    alert((resp && resp.responseJSON && resp.responseJSON.description) || "Could not add to cart.");
                    });
                } else {
                console.warn("cartAdd function is not available in the global scope.");
                }
            });

    // ============================================================
    // WISHLIST → MOVE TO CART (poll until widget exists, then bind once)
    // ============================================================
    let ic = false;
    const wishlistPoll = setInterval(function () {
        if (ic) { clearInterval(wishlistPoll); return; }
        if ($(".wishlist-move-cart").length) {
            ic = true;
            clearInterval(wishlistPoll);

            $(".wishlist-move-cart").click(function (e) {
                e.preventDefault();
                let is = false;
                const popupPoll = setInterval(function () {
                    if (is) { clearInterval(popupPoll); return; }
                    if ($(".wishlist-popup").length) {
                        is = true;
                        clearInterval(popupPoll);
                        openDrawer(true);
                        refreshDrawerOnly();
                    }
                }, 50);
                setTimeout(() => clearInterval(popupPoll), 2000);
            });
        }
    }, 50);
    setTimeout(() => clearInterval(wishlistPoll), 2000);

    // ============================================================
    // QUICK-ADD (mobile) — product recommendations carousel
    // ============================================================
    if (window.matchMedia("(max-width: 749px)").matches) {
        $(".quick-add-btn .button-unstyled").click(function () {
            $(".card-options-wrapper").removeClass("active");
            $(this).closest(".card-options-wrapper").addClass("active");
        });
    }

    let i_quick = false;
    const quickAddPoll = setInterval(function () {
        if (i_quick) { clearInterval(quickAddPoll); return; }
        if ($("product-recommendations .quick-add-btn .button-unstyled").length) {
            i_quick = true;
            clearInterval(quickAddPoll);

            if (window.matchMedia("(max-width: 749px)").matches) {
                $("product-recommendations .quick-add-btn .button-unstyled").click(function () {
                    $("product-recommendations .card-options-wrapper").removeClass("active");
                    $(this).closest("product-recommendations .card-options-wrapper").addClass("active");
                });
            }
            // Note: .card__size-value button click handling is already bound
            // globally via the delegated handler earlier in this file, so we
            // don't need to duplicate it here.
        }
    }, 50);
    setTimeout(() => clearInterval(quickAddPoll), 4000);

    // ============================================================
    // SLIDER ARROWS
    // ============================================================
    $(".next_arrow").click(function () {
        let $btn = $(this);
        setTimeout(function () {
            if ($btn.closest("slider-component").find(".slider-button--next").attr("disabled") == "disabled") {
                $btn.addClass("inactive");
            }
        }, 300);
        $(this).closest("slider-component").find(".prev_arrow").removeClass("inactive");
        $(this).closest("slider-component").find(".slider-button--next").click();
    });

    $(".prev_arrow").click(function () {
        let $btn = $(this);
        setTimeout(function () {
            if ($btn.closest("slider-component").find(".slider-button--prev").attr("disabled") == "disabled") {
                $btn.addClass("inactive");
            }
        }, 300);
        $(this).closest("slider-component").find(".next_arrow").removeClass("inactive");
        $(this).closest("slider-component").find(".slider-button--prev").click();
    });
document.querySelector('.elements_total [href="/cart"]')?.addEventListener('click', function(e) {
  e.preventDefault();

  const button = this;
  const spinner = button.querySelector(".loading__spinner");
  const labelSpan = button.querySelector("span");

  // Show spinner, hide label text
  if (spinner) spinner.classList.remove("hidden");
  if (labelSpan) labelSpan.classList.add("hidden");

  // Collect items from all target forms
  const forms = document.querySelectorAll('.c_cart_product form');
  const items = [];

  forms.forEach(form => {
    const itemData = serializedFormToItems($(form));
    if (itemData) items.push(itemData);
  });

  // Include free products form if active
  if ($(".p_free_products_form form").length) {
    items.push(serializedFormToItems($(".p_free_products_form form")));
  }

  if (items.length === 0) {
    resetUI();
    return;
  }

  function resetUI() {
    setTimeout(() => {
      if (spinner) spinner.classList.add("hidden");
      if (labelSpan) labelSpan.classList.remove("hidden");
    }, 1000);
  }

  // Open the slide-out cart drawer
  if (typeof openDrawer === 'function') {
    openDrawer(true);
  }

  // Submit items using native cart logic
  Promise.resolve(cartAdd(items))
    .then(function (response) {
      if (typeof renderCartSections === 'function') {
        renderCartSections(response);
      }
      if (typeof syncFreeProducts === 'function') {
        return syncFreeProducts(response);
      }
    })
    .catch(function (resp) {
      $(".inline-cart").removeClass("is-loading");
      const desc = resp && resp.responseJSON && resp.responseJSON.description;
      alert(desc || "Could not update your cart.");
    })
    .finally(function () {
      resetUI();
    });
});
document.addEventListener('click', function(e) {
  const add_to_cart = e.target.closest('.c_discount_popups .add-to-cart');

  if (add_to_cart) {
      const $btn = $(add_to_cart);
      const $productInfo = $btn.closest(".product_info");
      const $productPopup = $btn.closest(".product-popup");
      const selected_var = $productInfo.find("[name=id]").val();

      e.preventDefault();
      $btn.addClass("active");
      console.log($productPopup);

      if ($(".custom_upsells").length) {
          $(".custom_upsells").addClass("active");
          return;
      }

      openDrawer(true);
      $btn.removeClass("active");
      $productPopup.hide();
      const items = [serializedFormToItems($productInfo)];
      // include selected_var in items here if your payload needs it explicitly

      cartAdd(items)
          .then(function (addResponse) {
              return cartFetch().then(function (cartData) {
                  const mergedResponse = Object.assign({}, addResponse, {
                      item_count: cartData.item_count
                  });
                  renderCartSections(mergedResponse);
                  return syncFreeProducts(cartData);
              });
          })
          .catch(function (resp) {
              $(".inline-cart").removeClass("is-loading");
              const desc = resp && resp.responseJSON && resp.responseJSON.description;
              alert(desc || "Could not add this item to your cart.");
          });
  }
});
});